import React from 'react';
import CurrencyField from 'components/ui/CurrencyField';
import { Checkbox, Input } from 'semantic-ui-react';
import { ArrearFormProps } from '../types';
import SelectWithFreeTyping from '../../SelectWithFreeTyping';
import TaxingAuthoritesDropdown from '../TaxingAuthoritesDropdown';
import TaxTypesDropdown from '../TaxTypesDropdown';
import Payoffs from '../Payoff/Payoffs';
import { XIcon } from 'components/ui/icons';
import HalfYearDropdown from '../HalfYearDropdpdown';
import TypeDropdown from '../TypeDropdown';

export default function BasicArrear(props: ArrearFormProps) {
  return (
    <div style={{ padding: 16, marginBottom: 8, backgroundColor: '#f5f5f5', borderRadius: 5 }}>
      <div style={{ display: 'flex' }}>
        <SelectWithFreeTyping
          text="Year:"
          value={props.arrear.year}
          onChange={e => props.changeArrears('year', e)}
          yearText={props.arrear.yearText}
          yearTextOnChange={e => props.changeArrears('yearText', e.target.value)}
        />
        <div style={{ marginLeft: 8 }}>
          <HalfYearDropdown
            text="Half Years:"
            value={props.arrear.halfYear}
            onChange={e => props.changeArrears('halfYear', e)}
          />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 8 }}>
          <span style={{ marginBottom: 8, display: 'inline-block', fontSize: 14, marginRight: 8 }}>
            Delinquent Tax Type:
          </span>
          <TaxTypesDropdown
            onChange={e => props.changeArrears('delinquentTaxType', e)}
            value={props.arrear.delinquentTaxType}
            taxingAuthorities={props.taxingAuthorities}
          />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 8 }}>
          <span style={{ marginBottom: 8, display: 'inline-block', fontSize: 14, marginRight: 8 }}>
            Type:
          </span>
          <TypeDropdown onChange={e => props.changeArrears('type', e)} value={props.arrear.type} />
        </div>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', marginTop: 8 }}>
        <span style={{ marginBottom: 8, display: 'inline-block', fontSize: 14, marginRight: 8 }}>
          Taxing Authority:
        </span>
        <TaxingAuthoritesDropdown
          onChange={e => props.changeArrears('taxingAuthority', e)}
          value={props.arrear.taxingAuthority}
          taxingAuthorities={props.taxingAuthorities}
        />
      </div>
      <Payoffs
        payoffs={props.arrear.payoffs}
        changePayoffInfo={props.changePayoffInfo}
        addPayOff={props.addPayoff}
        deletePayoff={props.deletePayoff}
      />
      {/* <div style={{ cursor: 'pointer', display: 'flex', marginTop: 24 }} onClick={addArrear}>
        <Icon name="plus" />
        <span style={{ fontWeight: 'bold', marginLeft: 4 }}>Add Date and Amount</span>
      </div> */}
      <div style={{ marginTop: 16 }}>
        <Checkbox
          label="In certified funds"
          checked={props.arrear.certifiedFunds}
          onChange={(e, { checked }) => props.changeArrears('certifiedFunds', checked)}
        />
      </div>
    </div>
  );
}
